import React from "react";
import Home from "./components/Home";
import { Routes, Route, Navigate } from "react-router-dom";
import Survey from "./pages/Survey";
import SurveyDetails from "./pages/SurveyDetails";
import SurveyResult from "./pages/SurveyResult";
import ScrollToAnchor from "./components/ScrollToAnchor";
import Error404 from "./errorsPage/404Error/Error404";
import Redirect from "./errorsPage/404Error/Redirect";
import Terms from "./pages/Terms";
import TermsIt from "./pages/TermsIt";
import Privacy from "./pages/Privacy";
import PrivacyIt from "./pages/PrivacyIt";
import Support from "./pages/Support";
import SupportIt from "./pages/SupportIt";
import ContestRules from "./pages/ContestRules";
import Magazine from "./pages/Magazine";
import AuthWrapper from "./Authentication/AuthWrapper";
import Login from "./Authentication/Login";
import SignUp from "./Authentication/SignUp";
import ForgetPassword from "./Authentication/ForgetPassword";
import VerifyCode from "./Authentication/VerifyCode";
import ResetPassword from "./Authentication/ResetPassword";
import ResetSuccessfull from "./Authentication/ResetSuccessfull";
import SaveConfirm from "./Authentication/SaveConfirm";
import CompleteProfile from "./Authentication/CompleteProfile";
import VerifyMobileOtp from "./Authentication/VerifyMobileOtp";
import ContributedDetails from "./pages/ContributedDetails";
import GetPhone from "./components/GetPhone";
import ProtectedRoute from "./components/ProtectedRoute";
import ChildAbuse from "./pages/ChildAbuse";
import ChildAbuseIt from "./pages/ChildAbuseIt";
const App = () => {
  return (
    <React.Fragment>
      <ScrollToAnchor />
      <Routes>
        <Route path="/auth" element={<AuthWrapper />}>
          <Route index element={<Login />} />
          <Route path="/auth/signup" element={<SignUp />} />
          <Route path="/auth/forget-password" element={<ForgetPassword />} />
          <Route path="/auth/verify-mobile-otp" element={<VerifyMobileOtp />} />
          <Route path="/auth/verify-otp" element={<VerifyCode />} />
          <Route path="/auth/get-phone" element={<GetPhone />} />
          <Route path="/auth/reset-password" element={<ResetPassword />} />
        </Route>
        <Route path="/reset-successfully" element={<ResetSuccessfull />} />
        <Route path="/save-confirm" element={<SaveConfirm />} />
        <Route path="/complete-profile" element={<CompleteProfile />} />

        <Route path='/' element={<Home />} />
        <Route path='/sondaggi' element={<Survey />} />
        <Route path='/survey-details/:id' element={
          <ProtectedRoute>
            <SurveyDetails />
          </ProtectedRoute>
        } />
        <Route path='/contributed-details/:id' element={<ContributedDetails />} />
        <Route path='/survey-results/:id' element={<SurveyResult />} />
        <Route path='/terms' element={<Terms />} />
        <Route path='/terms/it' element={<TermsIt />} />
        <Route path='/privacy' element={<Privacy />} />
        <Route path='/privacy/it' element={<PrivacyIt />} />
        <Route path='/child-abuse' element={<ChildAbuse />} />
        <Route path='/child-abuse/it' element={<ChildAbuseIt />} />
        <Route path='/support' element={<Support />} />
        <Route path='/support/it' element={<SupportIt />} />
        <Route path='/regolamento' element={<ContestRules />} />
        <Route path='/magazine' element={<Magazine />} />
        <Route path='*' element={<Redirect />} />
      </Routes>
    </React.Fragment>
  )
};

export default App;